"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAxios = void 0;
Object.defineProperty(exports, "requestLogger", {
  enumerable: true,
  get: function () {
    return _logger.requestLogger;
  }
});
Object.defineProperty(exports, "responseErrorLogger", {
  enumerable: true,
  get: function () {
    return _logger.responseErrorLogger;
  }
});
Object.defineProperty(exports, "responseLogger", {
  enumerable: true,
  get: function () {
    return _logger.responseLogger;
  }
});
Object.defineProperty(exports, "withBearerToken", {
  enumerable: true,
  get: function () {
    return _oauth.withBearerToken;
  }
});
Object.defineProperty(exports, "withCircuitBreaker", {
  enumerable: true,
  get: function () {
    return _circuitbreaker.withCircuitBreaker;
  }
});
var _axios = _interopRequireDefault(require("axios"));
var _logger = require("./logger");
var _oauth = require("./oauth");
var _circuitbreaker = require("./circuitbreaker");
const compose = (...interceptors) => {
  return async config => {
    let res = config;
    for (const interceptor of interceptors) {
      res = await interceptor(config);
    }
    return res;
  };
};
const createAxios = (logger, extraRequestInterceptors = [], extraResponseInterceptors = [], axiosInstance = _axios.default.create()) => {
  axiosInstance.interceptors.request.use(compose((0, _logger.requestLogger)(logger), ...extraRequestInterceptors), logger.error);
  axiosInstance.interceptors.response.use(compose((0, _logger.responseLogger)(logger), ...extraResponseInterceptors), (0, _logger.responseErrorLogger)(logger));
  return axiosInstance;
};
exports.createAxios = createAxios;
//# sourceMappingURL=index.js.map